import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import '../../assets/css/Profile.css';

function NotificationSettings() {
    const navigate = useNavigate();
    const [settings, setSettings] = useState({
        matchNotification: false,
        messageNotification: false,
        nearbyUsersNotification: false,
        eventActivityNotification: false,
    });

    const notificationOptions = [
        { key: "matchNotification", label: "Match Notification" },
        { key: "messageNotification", label: "Message Notification" },
        { key: "nearbyUsersNotification", label: "New Nearby Users Notification" },
        { key: "eventActivityNotification", label: "Event or Activity Notification" },
    ];

    const handleToggle = (key) => {
        setSettings((prevSettings) => ({
            ...prevSettings,
            [key]: !prevSettings[key],
        }));
    };

    const handleSave = () => {
        alert("Settings saved!");
    };

    return (
        <div className=" w-100 notifiction-container">
            <div className="row justify-content-center">
                <div className=" p-4">
                    <div className="row">
                        <div className="d-flex justify-content-between notification-setting-txt" >
                            <div className="mb-4 text-center" style={{ fontSize: '20px', fontWeight: '600' }}>
                                Notification Setting
                            </div>
                        </div>
                    </div>
                    {notificationOptions.map((option) => (
                        <div key={option.key} className="form-check form-switch mb-4 d-flex justify-content-between">
                            <label className="form-check-label" htmlFor={option.key}>
                                {option.label}
                            </label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={option.key}
                                checked={settings[option.key]}
                                onChange={() => handleToggle(option.key)}
                            />
                        </div>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'center' }} className="mt-5">
                        <button className="btn btn-primary w-100" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotificationSettings;
